// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';


// For CKEditor
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import viewToPlainText from '@ckeditor/ckeditor5-clipboard/src/utils/viewtoplaintext';
// import './DocCmtAddDialog.css';

export default function DocCmtAddDialog(props) {

  const { sysID, open, onClose, docDetail, afterUpdate, editMode, editCmt } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }


  const handleCloseClick = () => {
    initData();

    onClose && onClose();
  }

  const initData = () => {

    setHtmlComment("");
  }

  const [htmlComment, setHtmlComment] = useState("");
  const [richEditor, setRichEditor] = useState(null);

  // Use when "open" changed
  useEffect(() => {
    // console.log("useEffect DocCmtAddDialog(open)");

    if (open && editMode && editCmt) {
      // console.log("init editor", editCmt);
      setHtmlComment(editCmt.Html);

    }

  }, [open])


  const handleSaveClick = () => {
    // console.log("htmlComment", htmlComment);
    const textComment = viewToPlainText(richEditor.editing.view.document.getRoot());
    // console.log("textComment", textComment);

    setShowLoading(true);

    let p1;
    if (editMode) {
      p1 = DmsService.commentUpdatePromise(gState.sessionID, sysID, docDetail.DocID, editCmt.id, textComment, htmlComment)
    } else {
      p1 = DmsService.commentAddPromise(gState.sessionID, sysID, docDetail.DocID, textComment, htmlComment)
    }

    p1
      .then(() => {

        setShowLoading(false);

        initData();
        afterUpdate && afterUpdate();

      })
      .catch((e) => {
        setShowLoading(false);

        console.log('Fail: ', e);

        onCatchPromiseError(e);

      })


  }


  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xl"}
      aria-describedby="add-comment-dialog-description"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />


      <DialogTitle id="alert-dialog-title">
        {editMode ? "Edit Comment" : "Add Comment"}
      </DialogTitle>
      <DialogContent>

        <Box sx={{ flexDirection: 'column', height: "70vh" }} >

          {/* <Box sx={{ height: 1, width: '100%', border: 1 }}> */}
          {/* <Box sx={{ display: 'block', overflow: "auto", border: 1, height: '100%', width: '100%' }} > */}

          {/* </Box> */}
          {/* </Box> */}

          <CKEditor
            editor={ClassicEditor}
            data={htmlComment}

            onReady={editor => {
              setRichEditor(editor);
              editor.editing.view.change((writer) => {
                writer.setStyle("height", "500px", editor.editing.view.document.getRoot());
              })
            }}
            onChange={(event, editor) => {
              const data = editor.getData();
              // console.log({ event, editor, data });
              setHtmlComment(data);
            }}
          // onBlur={(event, editor) => {
          //   console.log('Blur.', editor);
          // }}
          // onFocus={(event, editor) => {
          //   console.log('Focus.', editor);
          // }}
          />

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Cancel</Button>
        <Button
          type="submit"
          variant="contained"
          startIcon={<SaveIcon />}
          disabled={htmlComment == ""}
          onClick={handleSaveClick}
        >
          Save
        </Button>

      </DialogActions>
    </Dialog>

  );
}

DocCmtAddDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  editMode: PropTypes.bool,
  editCmt: PropTypes.object,
  docDetail: PropTypes.object,
  afterUpdate: PropTypes.func,
};


